import { BaseUserProfile } from 'fitbeat.models';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { View } from 'react-native';
import { connect } from 'react-redux';
import { Button, ButtonTypes } from '../../components';
import { IAppStore } from '../../HomeWorkouts';
import UpdateAvatar from '../../Profile/components/UpdateAvatar';
import Theme from '../../theme';
import { defaultScale, UserDataConsumer } from '../../utils';
import { styles as SharedStyles } from '../SignupFormsStyles';
import {
  nextPressed,
  skipPressed,
} from './capture-avatar-actions';

interface IProps {
  user: {
    userProfile: BaseUserProfile;
  };
  loading: boolean;
  nextPressed: (userId: string, navigation: any) => void;
  skipPressed: (navigation: any) => void;
  navigation: any;
  t: (key: string, options?: any) => string;
}

export class OnboardingCaptureAvatar extends PureComponent<IProps> {

  public render() {
    const {
      t,
      user: { userProfile },
      loading,
    } = this.props;
    return (
      <View style={SharedStyles.container}>
        <UpdateAvatar
          actions={(
            <>
              <Button
                fontColor={Theme.WHITE}
                onPress={() => this.props.nextPressed(userProfile.uid, this.props.navigation)}
                isLoading={loading}
                title={t('auth:next')}
              />

              <Button
                fontColor={Theme.PRIMARY}
                buttonType={ButtonTypes.TRANSPARENT}
                containerStyle={{ marginVertical: defaultScale(10) }}
                onPress={() => this.props.skipPressed(this.props.navigation)}
                title={t('auth:appOnboardingSkip')}
                disabled={loading}
              />
            </>
          )}
        />
      </View>
    );
  }
}

const mapStateToProps = (state: IAppStore) => ({
  loading: state.auth.signup.uploadingAvatar,
  uploadedAvatar: state.auth.signup.uploadedAvatar,
  existingAvatar: state.auth.signup.existingAvatar,
});

const mapDispatchToProps = ({
  nextPressed,
  skipPressed,
});

export default translate(['auth'], { wait: true })(
  connect(mapStateToProps, mapDispatchToProps)(UserDataConsumer(OnboardingCaptureAvatar)));
